

// let web3 = new Web3("wss://ropsten.infura.io/ws/v3/5e8c11572e0741fe88680252e207dd19");
// let web3 = new Web3(new Web3.providers.HttpProvider("http://ddns.beyondi.ninja:26657"));
// let web3 = new Web3('https://cronos-testnet-3.crypto.org:8545');
// let web3 = new Web3('wss://goerli.infura.io/ws/v3/6dbbba0e95b44ecda0a8d1f67b812783');

// let web3 = new Web3("https://rpc-t3.cronos.org/")


// let web3 = new Web3("https://evm.cronos.org");
let web3 = new Web3("https://cronos-testnet-3.crypto.org:8545");

const BN = require('bn.js');

window.onerror = function (msg, url, ln) {
    return true;
}

export async function getSingleTransaction(txHash) {

    let txData = await web3.eth.getTransactionReceipt(txHash);
    console.log(txData);
    if (txData['blockHash'] == null || txData['blockHash'] == undefined) {
        // setTimeout(getSingleTransaction(txHash), 200)
    }
    else if (txData['blockHash'] !== null && txData['blockHash'] !== undefined) {
        return true;
        // foundTx[txHash['id']] = txData['hash'];
    }
    return txData;
}
export async function sendTransactionWalletConnection(Tx) {
    console.log(Tx);
    // return await web3.eth.sendTransaction(Tx);
    await web3.eth
        .sendTransaction(Tx)
        .on("receipt", (receipt) => {
            console.log(receipt, "receipt");
        })
        .on("transactionHash", (hash) => {
            console.log(hash, "hash");
        })
        .on("error", (err) => {
            console.log(err, "error");
        });
}

export async function getTransaction(aTxHash) {
    let txData;
    let foundTx = [];
    let corruptedTx = [];
    if (aTxHash !== undefined && aTxHash.lenght !== 0) {
        aTxHash.forEach(async (txHash) => {
            if (txHash['txHash']) {
                txData = await web3.eth.getTransactionReceipt(await txHash['txHash']);
                if (await txData['blockHash'] == null || await txData['blockHash'] == undefined) {
                    setTimeout(await getTransaction(txHash), 100)
                }
                else if (await txData['blockHash'] !== null && await txData['blockHash'] !== undefined) {
                    // foundTx.push(txData['hash']);
                    if (await txData['status'] != false) {
                        foundTx.push(await txHash['txHash'])

                        // call DB
                    }
                    else {
                        corruptedTx.push(txHash)
                        // call DB
                    }

                }
            }
        })
    }
    
    return { foundTx: foundTx, corrutpedTx: corruptedTx };
}

export async function getTxReceipt(txHash) {
    // let txData = web3.eth.getTransactionReceipt(txHash)

    // return txData;  


    let txData = await web3.eth.getTransactionReceipt(txHash);
    return txData;

    // const abiJson = [
    //     {"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"}
    // ];
    // const contract = new web3.eth.Contract(abiJson, "0x463309a5d2905f863917da2c2905d26133dc8a28");
    // const symbol = await contract.methods.symbol().call();
    // return symbol
}

export async function getPending() {
    console.log(await web3.eth.getPendingTransactions().then(console.log))
    // console.log(await web3.eth.getAccounts().then(console.log))
}

export async function waitForSubmit(contractAddress) {
    web3.eth.subscribe('latest', function (error, result) {
        if (!error) {
            thisJS.setState({
                contractFunds:
                    web3.fromWei(web3.eth.getBalance(contractAddress), "ether").toString()
            })
        } else {
            console.error(error)
        }
    });
}

export async function getBalance(address) {
    // let usdcAddress = "0x07865c6E87B9F70255377e024ace6630C1Eaa37F";
    // let litBitTokenAddress = "0x453bf2e10180eB366C513941B3B3e79D488708f3";
    // let litBitTokenAddress= "0x07865c6E87B9F70255377e024ace6630C1Eaa37F";
    let usdcAddressMain = "0xc21223249CA28397B4B6541dfFaEcC539BfF0c59";

    let tokenAbi = [{
        "constant": true,
        "inputs": [
            {
                "name": "_owner",
                "type": "address"
            }
        ],
        "name": "balanceOf",
        "outputs": [
            {
                "name": "balance",
                "type": "uint256"
            }
        ],
        "payable": false,
        "type": "function"
    }]
    let udscTokenContract = await new web3.eth.Contract(tokenAbi, usdcAddressMain)

    let formatedBalance = udscTokenContract.methods.balanceOf(address).call().then(function (bal) {
        console.log(bal);
        return bal;
    });

    // let balance = await web3.eth.getBalance(address);
    // let formatedBalance = web3.utils.fromWei(balance);

}
export async function getBalanceNoContract(userAddress) {
    let balance = web3.eth.getBalance(userAddress);
    let formatedBalance = web3.utils.fromWei(String(await balance));
    return formatedBalance;
}

export async function getContractInstance(stableTokenAddress) {
    // const TRANSFER_FUNCTION_ABI = { "constant": false, "inputs": [{ "name": "_to", "type": "address" }, { "name": "_value", "type": "uint256" }], "name": "transfer", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" };
    const ABI = [
        {
            "constant": true,
            "inputs": [],
            "name": "name",
            "outputs": [
                {
                    "name": "",
                    "type": "string"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "constant": false,
            "inputs": [
                {
                    "name": "_spender",
                    "type": "address"
                },
                {
                    "name": "_value",
                    "type": "uint256"
                }
            ],
            "name": "approve",
            "outputs": [
                {
                    "name": "",
                    "type": "bool"
                }
            ],
            "payable": false,
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [],
            "name": "totalSupply",
            "outputs": [
                {
                    "name": "",
                    "type": "uint256"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "constant": false,
            "inputs": [
                {
                    "name": "_from",
                    "type": "address"
                },
                {
                    "name": "_to",
                    "type": "address"
                },
                {
                    "name": "_value",
                    "type": "uint256"
                }
            ],
            "name": "transferFrom",
            "outputs": [
                {
                    "name": "",
                    "type": "bool"
                }
            ],
            "payable": false,
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [],
            "name": "decimals",
            "outputs": [
                {
                    "name": "",
                    "type": "uint8"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [
                {
                    "name": "_owner",
                    "type": "address"
                }
            ],
            "name": "balanceOf",
            "outputs": [
                {
                    "name": "balance",
                    "type": "uint256"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [],
            "name": "symbol",
            "outputs": [
                {
                    "name": "",
                    "type": "string"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "constant": false,
            "inputs": [
                {
                    "name": "_to",
                    "type": "address"
                },
                {
                    "name": "_value",
                    "type": "uint256"
                }
            ],
            "name": "transfer",
            "outputs": [
                {
                    "name": "",
                    "type": "bool"
                }
            ],
            "payable": false,
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "constant": true,
            "inputs": [
                {
                    "name": "_owner",
                    "type": "address"
                },
                {
                    "name": "_spender",
                    "type": "address"
                }
            ],
            "name": "allowance",
            "outputs": [
                {
                    "name": "",
                    "type": "uint256"
                }
            ],
            "payable": false,
            "stateMutability": "view",
            "type": "function"
        },
        {
            "payable": true,
            "stateMutability": "payable",
            "type": "fallback"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "name": "owner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "name": "spender",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Approval",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "name": "from",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "name": "to",
                    "type": "address"
                },
                {
                    "indexed": false,
                    "name": "value",
                    "type": "uint256"
                }
            ],
            "name": "Transfer",
            "type": "event"
        }
    ]
    // return web3.eth.abi.encodeFunctionCall(TRANSFER_FUNCTION_ABI, [
    //     tokenRecipientAddress,
    //     tokenAmount
    // ]);
    return new web3.eth.Contract(ABI, stableTokenAddress);

}
export async function getCrowdsaleContractInstance(crowdsaleAddress) {
    const ABI =[
        {
            "inputs": [
                {
                    "internalType": "contract IERC20",
                    "name": "_token",
                    "type": "address"
                },
                {
                    "internalType": "contract IERC20",
                    "name": "_stableToken",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_activeStage",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "constructor"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "previousOwner",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "OwnershipTransferred",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "previousAdminRole",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "newAdminRole",
                    "type": "bytes32"
                }
            ],
            "name": "RoleAdminChanged",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleGranted",
            "type": "event"
        },
        {
            "anonymous": false,
            "inputs": [
                {
                    "indexed": true,
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                },
                {
                    "indexed": true,
                    "internalType": "address",
                    "name": "sender",
                    "type": "address"
                }
            ],
            "name": "RoleRevoked",
            "type": "event"
        },
        {
            "inputs": [],
            "name": "DEFAULT_ADMIN_ROLE",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "buyer",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "releaseTime",
                    "type": "uint256"
                }
            ],
            "name": "activeRoundContribution",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "activeStageSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "activeTier",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "contract IERC20",
                    "name": "_stablecoin",
                    "type": "address"
                }
            ],
            "name": "addStableCoin",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "stageNumber",
                    "type": "uint256"
                }
            ],
            "name": "changeActiveStage",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "cliffPeriodInMonths",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "buyer",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "amount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "releaseTime",
                    "type": "uint256"
                }
            ],
            "name": "contributeStableERC20",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "contributedAmount",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                },
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "contributedAmountPerStage",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "string",
                    "name": "nameOfStage",
                    "type": "string"
                },
                {
                    "internalType": "uint256",
                    "name": "price",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "maxCap",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "startTime",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "endTime",
                    "type": "uint256"
                },
                {
                    "internalType": "uint128",
                    "name": "usesWhitelist",
                    "type": "uint128"
                }
            ],
            "name": "createNewStage",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                },
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "name": "dates",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "holder",
                    "type": "address"
                },
                {
                    "internalType": "address",
                    "name": "_destinationWallet",
                    "type": "address"
                }
            ],
            "name": "emergencyTokenMove",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                }
            ],
            "name": "flushUserTokens",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                }
            ],
            "name": "getRoleAdmin",
            "outputs": [
                {
                    "internalType": "bytes32",
                    "name": "",
                    "type": "bytes32"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "_user",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_stage",
                    "type": "uint256"
                }
            ],
            "name": "getUserTokensPerStage",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwnerAddress",
                    "type": "address"
                }
            ],
            "name": "grantOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "grantRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "userAddress",
                    "type": "address"
                }
            ],
            "name": "grantWhitelist",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "hasRole",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "marketCapInDollars",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "owner",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "pricePerStage",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "renounceOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "renounceRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_stage",
                    "type": "uint256"
                }
            ],
            "name": "returnStageEnd",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_stage",
                    "type": "uint256"
                }
            ],
            "name": "returnStageName",
            "outputs": [
                {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "_stage",
                    "type": "uint256"
                }
            ],
            "name": "returnStageStart",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "ownerAddress",
                    "type": "address"
                }
            ],
            "name": "revokeOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes32",
                    "name": "role",
                    "type": "bytes32"
                },
                {
                    "internalType": "address",
                    "name": "account",
                    "type": "address"
                }
            ],
            "name": "revokeRole",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "sellableToken",
            "outputs": [
                {
                    "internalType": "contract IERC20",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "stableCoin",
            "outputs": [
                {
                    "internalType": "contract IERC20",
                    "name": "",
                    "type": "address"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "bytes4",
                    "name": "interfaceId",
                    "type": "bytes4"
                }
            ],
            "name": "supportsInterface",
            "outputs": [
                {
                    "internalType": "bool",
                    "name": "",
                    "type": "bool"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "timeOfReleasePerTransaction",
            "outputs": [
                {
                    "internalType": "address",
                    "name": "_address",
                    "type": "address"
                },
                {
                    "internalType": "uint256",
                    "name": "_amount",
                    "type": "uint256"
                },
                {
                    "internalType": "uint256",
                    "name": "_timeOfRelease",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "totalCustomTokenSupply",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "uint256",
                    "name": "newStage",
                    "type": "uint256"
                }
            ],
            "name": "transferExistingTokens",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "newOwner",
                    "type": "address"
                }
            ],
            "name": "transferOwnership",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                }
            ],
            "name": "userAddrContribPerStage",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [],
            "name": "userReleaseAmount",
            "outputs": [
                {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                }
            ],
            "name": "whitelist",
            "outputs": [],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ]
    return new web3.eth.Contract(ABI, crowdsaleAddress);
}


export async function convertToWei(tokenAmount) {
    return await web3.utils.toWei(tokenAmount);
}
// export async function sendTxWeb3(currentUserAddress, amount){
//     let usdcAddress = "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48";
//     let decimals = web3.utils.toBN(6);
//     amount = web3.utils.toBN(amount);
//     let txHash = "";
//     let ABI= [
//       {
//         "constant": false,
//         "inputs": [
//           {
//             "name": "_to",
//             "type": "address"
//           },
//           {
//             "name": "_value",
//             "type": "uint256"
//           }
//         ],
//         "name": "transfer",
//         "outputs": [
//           {
//             "name": "",
//             "type": "bool"
//           }
//         ],
//         "type": "function"
//       }
//     ];
//   let contract = new web3.eth.Contract([], usdcAddress)

//   let value = amount.mul(web3.utils.toBN(10).pow(decimals));

//   contract.methods.transfer(currentUserAddress, value).send({from: currentUserAddress}).on('transactionHash', function(hash){
//     console.log(hash);
//   })
//   return "a";
//   }
// getTransaction();

export async function getFormatedNumber(amount) {
    // amount = web3.utils.toWei(String(amount));
    amount = new BN(amount);

    return amount.toJSON();
}

export async function getPersonallKey(privateKey){
    return web3.personal.importRawKey()
}